"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _index = _interopRequireDefault(require("./index"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;
  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
var RadioController = function RadioController(_ref) {
  var name = _ref.name,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    data = _ref.data,
    value = _ref.value,
    setFieldValue = _ref.setFieldValue,
    light = _ref.light,
    _ref$required = _ref.required,
    required = _ref$required === void 0 ? false : _ref$required,
    _ref$reset = _ref.reset,
    reset = _ref$reset === void 0 ? false : _ref$reset,
    setReset = _ref.setReset;
  var resetField = value === 'reset' || reset;
  var _React$useState = _react.default.useState(value),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    radioValue = _React$useState2[0],
    setRadioValue = _React$useState2[1];
  var handleChange = function handleChange(event) {
    setReset && setReset(false);
    setRadioValue(event.target.value);
    setFieldValue(name, event.target.value);
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_index.default.Group, {
    name: name,
    value: radioValue,
    onChange: function onChange(event) {
      return handleChange(event);
    },
    reset: resetField,
    setRadioValue: setRadioValue
  }, data.map(function (_ref2) {
    var id = _ref2.id,
      name = _ref2.name;
    return /*#__PURE__*/_react.default.createElement(_index.default.Radio, {
      key: id,
      value: id,
      disabled: disabled,
      light: light,
      required: required
    }, name);
  })));
};
var _default = RadioController;
exports.default = _default;